module.exports = __webpack_public_path__ + "static/img/designGuide11.c43d0a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/designGuide11.png
// module id = gUld
// module chunks = 2